import useFetch, { Method } from './useFetch'
import { useToken } from './useLoginWallet'

export type PostCreateParams = {
  file?: File
  replyId?: number
  tokenId: number
  msg: string
}

const usePostCreate = (
  params?: FormData,
  callback?: Parameters<typeof useFetch>[3]
) => {
  const { token } = useToken()

  const { data, ...rest } = useFetch(
    params && token ? '/user/post/create' : null,
    Method.POST,
    params,
    callback
  )

  return {
    data,
    ...rest
  }
}

export default usePostCreate
